import React from 'react';
import type {BoxProps} from '@tempo/core';
import Row from './Row';

type CollapsibleRowProps = {
	children: React.ReactNode;
	index: number;
	collapsedContent?: React.ReactNode;
	isCollapsed: boolean;
	onToggle: () => void;
} & BoxProps;

const CollapsibleRow = ({
	children,
	collapsedContent,
	isCollapsed,
	onToggle,
	...rest
}: CollapsibleRowProps) => {
	return (
		<>
			<Row onClick={onToggle} isClickable {...rest}>
				{children}
			</Row>
			{!isCollapsed && collapsedContent}
		</>
	);
};

export default CollapsibleRow;
